import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import LandingPage from "../landingpage/LandingPage";
import Header from "../../components/header/Header";
import QuestionareForm from "../../components/questionareForm/QuestionareForm";
import QuestionareNext from "../../components/questionareNext/QuestionareNext";
import QuestionareSecondStep from "../../components/questionareSecondStep/QuestionareSecondStep";
import ConsentForm from "../../components/consentform/ConsentForm";
import AppointmentBook from "../../components/appointmentbook/AppointmentBook";
import QuestionareSteps from "../../components/questionareSteps/QuestionareSteps";
import "./Questionare.css";
import axios from "axios";
import { isArray } from "highcharts";

var consentShowOthers = false;

const Questionare = () => {
  let navigate = useNavigate();
  const [painScale, setPainScale] = useState(0);
  const [
    //sectionsRemaining,
    setSectionsRemaining,
  ] = useState("");
  useEffect(() => {
    window.onbeforeunload = function (e) {
      e.preventDefault();
      return "Save unsaved changes?";
    };
  }, []);
  const [scndStepLength, setScndStepLength] = useState(-1);
  const [scndStepSubNumber, setScndStepSubNumber] = useState(-1);
  const [questionsDone, setQuestionsDone] = useState(0);
  const [errorQuestions, setErrorQuestions] = useState(false);
  const [toQuestionaire, setToQuestionaire] = useState(false);
  const [skipCustomQuestionaire, setSkipCustomQuestionaire] = useState(false);
  const [questionnaireToCheck, setQuestionnaireToCheck] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState(0);
  const [hideHeader, setHideHeader] = useState(false);
  const [canProceed, setCanProceed] = useState(false);
  const [height] = useState(["5", "5"]);
  const [weight] = useState(120);
  const [disableOneToOne, setDisableOneToOne] = useState(false);

  const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : "";
  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "user/checkOtpVerified", {})
      .then((res) => {
        if (res.data.responseData) {
          axios
            .post(window.ajaxLink + "cloud_questionnaires/get-questionnaire", {
              questionnaire_type: "Initial Questionnaire",
            })
            .then((res) => {
              if (res.data.responseData) {
                setAllQuestions(res.data.responseData);
                setAllQuestionsMain(res.data.responseData);
                setQuestionnaireToCheck(res.data.responseData.questionnaireIdCheck);
                // axios
                // .post(window.ajaxLink + "cloud_questionnaires/get-initial-answers", {
                // })
                // .then((res) => {

                // });

                countQuestions(res.data.responseData);

                var sectionsRemain = res.data.responseData.sections_remaining;

                if (sectionsRemain > 0) {
                  if (res.data.responseData.disable_quest === 1 && res.data.responseData.disable_oneonone === 0) {
                      setCurrentStep(4);
                      setToQuestionaire(false);
                      setConsentAnswerType("No");
                  }
                  else if (res.data.responseData.disable_quest === 1 && res.data.responseData.disable_oneonone === 1) {
                      setCurrentStep(4);
                      setToQuestionaire(false);
                      setConsentAnswerType("No");
                      setDisableOneToOne(true);
                  } else {
                  setCurrentStep(1);
                  setErrorQuestions(false);
                  setStepsCompleted(0);
                }
                } else if (sectionsRemain === 0 || sectionsRemain < 0 ) {
                  if (res.data.responseData.disable_oneonone === 1 && res.data.responseData.disable_quest === 0) {
                      setDisableOneToOne(true);
                  }
                  if (res.data.responseData.bookedAppointment === 0 && res.data.responseData.didQuestionnaire === 0) {
                    setCurrentStep(4);
                    setConsentAnswerType("No");
                  } else if (res.data.responseData.bookedAppointment > 0 && res.data.responseData.didQuestionnaire === 0) {
                    setHideHeader(true);
                    setToQuestionaire(true);
                    setConsentAnswerType("No");
                    setCurrentStep(4);
                  } else if (res.data.responseData.didQuestionnaire === 1 || res.data.responseData.didQuestionnaire === 2 ) {
                    /* setCurrentStep(3);
                    setErrorQuestions(false);
                    setStepsCompleted(2); */
                    navigate("/landing");
                  }
                } else if (sectionsRemain === null) {
                  setCanProceed(true);
                  setCurrentStep(1);
                  //first time login sectionsRemain is null every next log in sectionsRemain is !== null
                  //if disable_quest is 1 on first log in will do this
                  if (res.data.responseData.disable_quest === 1 && res.data.responseData.disable_oneonone === 0) {

                    if (res.data.responseData.bookedAppointment === 0) {
                      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
                      axios
                        .post(window.ajaxLink + "cloud_questionnaires/save-initial-first-step", {
                          answers: { 1: "Lower Back" },
                        })
                        .catch((error) => {
                          console.error(error);
                        });

                      setCurrentStep(4);
                      setToQuestionaire(false);
                      setConsentAnswerType("No");
                      }
                  } else if (res.data.responseData.disable_quest === 1 && res.data.responseData.disable_oneonone === 1) {
                    if (res.data.responseData.bookedAppointment === 0) {
                      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
                      axios
                        .post(window.ajaxLink + "cloud_questionnaires/save-initial-first-step", {
                          answers: { 1: "Lower Back" },
                        })
                        .catch((error) => {
                          console.error(error);
                        });

                      setCurrentStep(4);
                      setToQuestionaire(false);
                      setConsentAnswerType("No");
                    }
                  }
                }
              }
              setPainScale(res.data.responseData.pain_scale);

              setIsLoading(false);
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
        navigate("/verify");
      });
  }, [navigate]);

  const numberOfMainQuestionsDone = (answers) => {
    if (allQuestions && allQuestions.sections && allQuestions.sections[1] && allQuestions.sections[1].questions) {
      var section2 = allQuestions.sections[1].questions.filter((question) => (parseFloat(question.question_number) % 1 !== 0) === false);
      var section3 = allQuestions.sections[2].questions.filter((question) => (parseFloat(question.question_number) % 1 !== 0) === false);

      var allMainQuestions = [...section2, ...section3];
      var mainIndices = [];

      for (var question of allMainQuestions) {
        mainIndices.push(question.question_id);
      }

      var totalAnswered = 0;

      for (var answer in answers) {
        if (parseInt(answer) >= mainIndices[0]) {
          if (Array.isArray(answers[answer])) {
            for (var checkAnswer of answers[answer]) {
              if (checkAnswer.isChecked === true && mainIndices.indexOf(parseInt(answer)) > -1) {
                totalAnswered++;
                break;
              }
            }
          } else if (mainIndices.indexOf(parseInt(answer)) > -1) {
            totalAnswered++;
          }
        }
      }
      setQuestionsDone(totalAnswered);
    }
  };

  const [allQuestions, setAllQuestions] = useState({});
  const [allQuestionsMain, setAllQuestionsMain] = useState({});
  const [mainProblemArea, setMainProblemArea] = useState(1);
  const [allAnswers, setAllAnswers] = useState({});
  const [stepsCompleted, setStepsCompleted] = useState(0);
  const [consentAnswerType, setConsentAnswerType] = useState("");

  useEffect(() => {
    handleMissingAnwers(allAnswers, allQuestions, currentStep);
  }, [allAnswers]);

  const handleStep = (step) => {
    if (step == 1) {
      setAllQuestions(allQuestionsMain);
    }

    if (step == 2) {
      filterProblemArea();
    }

    if (step === 1 || (step === 2 && stepsCompleted === 2)) {
      setCurrentStep(step);
      setErrorQuestions(false);
      handleProceed(allAnswers, allQuestions, step);
      window.scroll(0, 0);
      setAllAnswers({});
    }
    if (step === 2) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_questionnaires/save-initial-first-step", {
          answers: allAnswers,
        })
        .then((res) => {
          if (res.data.responseData) {
            setCurrentStep(step);
            setErrorQuestions(false);
            setStepsCompleted(1);

            for (var answ of allQuestions.sections[1].questions) {
              for (var ans of answ.answers) {
                if (ans.isChecked) {
                  ans.isChecked = false;
                }
              }
            }

            handleProceed(allAnswers, allQuestions, step);
            window.scroll(0, 0);
            setAllAnswers({});
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    if (step === 3) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_questionnaires/save-initial-second-step", {
          answers: allAnswers,
        })
        .then((res) => {
          if (res.data.responseData) {
            setCurrentStep(step);
            setErrorQuestions(false);
            setStepsCompleted(2);

            for (var answ of allQuestions.sections[1].questions) {
              for (var ans of answ.answers) {
                if (ans.isChecked) {
                  ans.isChecked = false;
                }
              }
            }
            for (var answ2 of allQuestions.sections[2].questions) {
              for (var ans2 of answ2.answers) {
                if (ans2.isChecked) {
                  ans2.isChecked = false;
                }
              }
            }

            handleProceed(allAnswers, allQuestions, step);
            window.scroll(0, 0);
            setAllAnswers({});
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    if (step === 4) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_questionnaires/save-consent-form", {
          answers: allAnswers,
        })
        .then((res) => {
          if (res.data.responseData) {
            setCurrentStep(step);
            setErrorQuestions(false);
            setStepsCompleted(3);

            for (var answ of allQuestions.sections[3].questions) {
              for (var ans of answ.answers) {
                //console.log(ans);
                if (ans.isChecked) {
                  ans.isChecked = false;
                }
              }
            }
            setBirthDate("");
            handleProceed(allAnswers, step);
            window.scroll(0, 0);
            setAllAnswers({});
            setPainScale(res.data.responseData.pain_scale);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleAnswer = (question, answer, questions) => {
    var fullNameData = JSON.parse(localStorage.getItem("userData"));
    let fullName = fullNameData.first_name + " " + fullNameData.last_name;
    var ansObj = { ...allAnswers };

    if (question && question[0] === 47 && currentStep === 3) {
      if (answer !== "Male") {
        ansObj[77] = 120;
        ansObj[76] = ["5", "5"];
      } else {
        ansObj[77] = 170;
        ansObj[76] = ["5", "10"];
      }
    }
    if (currentStep === 3) {
      ansObj[76] = ansObj[76] ? ansObj[76] : height;
      ansObj[77] = ansObj[77] ? ansObj[77] : weight;
      ansObj[25] = fullName ? fullName : "";
      //console.log("dte", ansObj[26]);
      // ansObj[26] = moment(userData.birthday).format("MM/DD/yyyy") ? moment(userData.birthday).format("MM/DD/yyyy") : "";
      ansObj[26] = userData.birthdayStr && moment(userData.birthdayStr).format("MM/DD/yyyy") ? moment(userData.birthdayStr).format("MM/DD/yyyy") : moment(userData.birthday).format("MM/DD/yyyy");

      ansObj[27] = moment().format("MM/DD/yyyy");
    }

    if (!isArray(question)) {
      ansObj[question] = answer;
      if (answer == 0) {
        delete ansObj[question];
      }
      if (answer === "None of the Above") {
        var questMain = { ...allQuestions };
        if (currentStep === 2) {
          for (var answ of allQuestions.sections[1].questions) {
            for (var ans of answ.answers) {
              if (ans.question_id === 3) {
                ans.isChecked = false;
              }
            }
          }
        } else if (currentStep === 3) {
          for (var answ1 of allQuestions.sections[3].questions) {
            for (var ans1 of answ1.answers) {
              ans1.isChecked = false;
            }
          }
        }
        setAllQuestions(questMain);
      }
      setAllAnswers(ansObj);
      handleProceed(ansObj, questions);
      numberOfMainQuestionsDone(ansObj);
    } else {
      ansObj[question[0]] = answer;
      if (answer == 0) {
        delete ansObj[question];
      }
      setAllAnswers(ansObj);
      handleProceed(ansObj, question[1]);
      numberOfMainQuestionsDone(ansObj);
    }
  };

  const handleAnswerHeight = (question, answer, questions) => {
    if (question[2] === 0) {
      height[question[2]] = answer;
    } else if (question[2] === 1) {
      height[question[2]] = answer;
    }

    var ansObj = { ...allAnswers };
    ansObj[question[0]] = height;
    setAllAnswers(ansObj);
    handleProceed(ansObj, question[1]);
    numberOfMainQuestionsDone(ansObj);
  };

  const handleMultiSelectAnswer = (question, answer, questions) => {
    var goalsMultiSelect = [];
    for (var oneQuest of question) {
      goalsMultiSelect.push(oneQuest.value);
    }

    var ansObj = { ...allAnswers };
    ansObj[answer[0]] = goalsMultiSelect;
    setAllAnswers(ansObj);
    handleProceed(ansObj, answer[1]);
    numberOfMainQuestionsDone(ansObj);
    if (ansObj[78] && ansObj[78].length === 0) {
      delete ansObj[78];
      setCanProceed(false);
    }
  };

  const handleChecked = (section, question, answer) => {
    var questMain = { ...allQuestions };
    var questExtr = { ...allQuestions.sections[section].questions[question] };
    var allAns = { ...allAnswers };
    if (allAns[questExtr.question_id] === "None of the Above") {
      for (var answ of allQuestions.sections[section].questions) {
        answ.isChecked = false;
      }
    }

    if (!allAns[questExtr.question_id] || allAns[questExtr.question_id] === "None of the Above") {
      allAns[questExtr.question_id] = [];
    }

    questExtr.answers[answer].isChecked = !questExtr.answers[answer].isChecked;
    if (!allAns[questExtr.question_id][answer]) {
      allAns[questExtr.question_id].push(questExtr.answers[answer]);
    } else {
      allAns[questExtr.question_id][answer] = questExtr.answers[answer];
    }

    questMain.sections[section].questions[question] = questExtr;
    setAllAnswers(allAns);
    setAllQuestions(questMain);
    handleProceed(allAns, allQuestions);
    numberOfMainQuestionsDone(allAns);
  };

  const filterProblemArea = () => {
    var originalQuestions = JSON.parse(JSON.stringify(allQuestions));
    for (var s = 0; s < originalQuestions.sections.length; s++) {
      var saveQuestions = [];
      for (var q = 0; q < originalQuestions.sections[s].questions.length; q++) {
        var useQuestion = false;
        if (originalQuestions.sections[s].questions[q].problem_condition) {
          var checkConditions = originalQuestions.sections[s].questions[q].problem_condition.split(",");
          if (checkConditions.indexOf(mainProblemArea + "") > -1) {
            useQuestion = true;
          }
        } else {
          useQuestion = true;
        }

        if (useQuestion) {
          var foundQuestion = JSON.parse(JSON.stringify(originalQuestions.sections[s].questions[q]));
          foundQuestion.answers = [];
          for (var a = 0; a < originalQuestions.sections[s].questions[q].answers.length; a++) {
            if (originalQuestions.sections[s].questions[q].answers[a].problem_condition) {
              var checkConditions = originalQuestions.sections[s].questions[q].answers[a].problem_condition.split(",");
              if (checkConditions.indexOf(mainProblemArea + "") > -1) {
                foundQuestion.answers.push(originalQuestions.sections[s].questions[q].answers[a]);
              } else {
              }
            } else {
              foundQuestion.answers.push(originalQuestions.sections[s].questions[q].answers[a]);
            }
          }
          saveQuestions.push(foundQuestion);
        }
      }

      originalQuestions.sections[s].questions = saveQuestions;
    }
    setAllQuestions(originalQuestions);

    countQuestions(originalQuestions);
  };

  const countQuestions = (dAllQuestions) => {
    var secondSection = dAllQuestions.sections[1].questions.filter((question) => (parseFloat(question.question_number) % 1 !== 0) === false);
    var scndWithSubNumber = dAllQuestions.sections[1].questions.filter((question) => parseFloat(question.question_number) > 0 && !question.is_optional);

    var thirdSection = dAllQuestions.sections[2].questions.filter((question) => (parseFloat(question.question_number) % 1 !== 0) === false);
    var thrdWithSubNumber = dAllQuestions.sections[2].questions.filter((question) => parseFloat(question.question_number) > 0 && !question.is_optional);

    setScndStepSubNumber(scndWithSubNumber.length + thrdWithSubNumber.length);
    setScndStepLength(secondSection.length + thirdSection.length);
  };

  const handleMainProblemArea = (area) => {
    setMainProblemArea(area);
  };

  const handleOther = (section, question, answer) => {
    var questExtr = { ...allQuestions.sections[section].questions[question] };
    var allAns = { ...allAnswers };
    if (allAns[questExtr.question_id]) {
      for (var answ of allAns[questExtr.question_id]) {
        if (answ.name === "Other") {
          answ.isOther = true;
        }
        if (answ.isOther) {
          answ.answer = answer;
        }
      }
    }
    setAllAnswers(allAns);
    numberOfMainQuestionsDone(allAns);
  };

  const getConsentWeight = (answers, questions) => {
    var targetId = allQuestions.sections[allQuestions.sections.length - 1].questions[0].answers[0].question_id || 0;
    var answerType = "No";
    var answerType2 = "No";

    var hasAnyGood = false;

    for (var answer in answers) {
      if (parseInt(answer) >= targetId) {
        if (Array.isArray(answers[answer])) {
          for (var checkAnswer of answers[answer]) {
            if (checkAnswer.answer_weight > 0 && checkAnswer.isChecked == true) {
              answerType = "Yes";

              if ([17, 18, 19, 20, 83, 82, 81].indexOf(parseInt(answer)) > -1) {
                answerType2 = "Yes";
              }

              if ([21, 22, 23].indexOf(parseInt(answer)) > -1) {
                hasAnyGood = true;
              }
            }
          }
        } else if (Array.isArray(questions)) {
          for (var question of questions) {
            if (question.question_id === parseInt(answer)) {
              for (var answerCollection of question.answers) {
                if (answerCollection.name === answers[answer] && answerCollection.answer_weight > 0) {
                  answerType = "Yes";

                  if ([17, 18, 19, 20, 83, 82, 81].indexOf(parseInt(question.question_id)) > -1) {
                    answerType2 = "Yes";
                  }

                  if ([21, 22, 23].indexOf(parseInt(question.question_id)) > -1) {
                    hasAnyGood = true;
                  }
                }
              }
            }
          }
        }
      }
    }

    consentShowOthers = answerType2 == "Yes";

    return hasAnyGood ? "No" : answerType;
  };

  const [missingAnsw, setMissingAnsw] = useState(0);

  const handleMissingAnwers = (answers) => {
    var isempt = Object.keys(answers);
    if (isempt.length > 0) {
      var secondSec = allQuestions.sections[1].questions.filter((question) => question.is_optional === false);
      var thirdSec = allQuestions.sections[2].questions.filter((question) => question.is_optional === false);

      var secondSecOpt = allQuestions.sections[1].questions.filter((question) => question.is_optional === true);
      var thirdSecOpt = allQuestions.sections[2].questions.filter((question) => question.is_optional === true);

      var allQuest = [...secondSec, ...thirdSec];
      var allQuestOpt = [...secondSecOpt, ...thirdSecOpt];
      var allReqQuestIndices = [];
      for (var q of allQuest) {
        allReqQuestIndices.push(q.question_id);
      }

      var reqAnswers = { ...answers };
      for (var optq of allQuestOpt) {
        delete reqAnswers[optq.question_id];
      }

      var availableIndices = [];
      for (var reqAns in reqAnswers) {
        availableIndices.push(parseInt(reqAns));
      }

      for (var oneInx of allReqQuestIndices) {
        if (availableIndices.indexOf(oneInx) === -1) {
          // console.log("Missing questions", availableIndices, oneInx, allReqQuestIndices, allQuestions);

          if (currentStep === 1) {
            oneInx = oneInx - 2;
          } else if (currentStep === 2) {
            oneInx = oneInx - 2;
          }

          if (oneInx === 14) {
            oneInx = 12;
          } else if (oneInx === 16) {
            oneInx = 13;
          }
          setMissingAnsw(Math.round(allQuest[oneInx]?.question_number));
          break;
        }
      }
    }
  };

  const handleProceed = (answers, questions, stepNew) => {
    if (Object.keys(answers).length === questions.length && (currentStep === 1 || stepNew === 1)) {
      setCanProceed(true);
    }

    if (currentStep === 2 || stepNew === 2) {
      // var painFirstStart = answers.painFirstStart.filter((item) => item.isChecked === true).length > 0;
      // var painType = answers.painType.filter((item) => item.isChecked === true).length > 0;
      // var currentPain = answers.currentPain.filter((item) => item.isChecked === true).length > 0;

      var isAllValid = Object.keys(answers).length >= scndStepSubNumber;
      if (isAllValid) {
        var secondSec = allQuestions.sections[1].questions.filter((question) => question.is_optional === false);
        var thirdSec = allQuestions.sections[2].questions.filter((question) => question.is_optional === false);

        var secondSecOpt = allQuestions.sections[1].questions.filter((question) => question.is_optional === true);
        var thirdSecOpt = allQuestions.sections[2].questions.filter((question) => question.is_optional === true);

        var allQuest = [...secondSec, ...thirdSec];
        var allQuestOpt = [...secondSecOpt, ...thirdSecOpt];
        var allReqQuestIndices = [];
        for (var q of allQuest) {
          allReqQuestIndices.push(q.question_id);
        }

        var reqAnswers = { ...answers };
        for (var optq of allQuestOpt) {
          delete reqAnswers[optq.question_id];
        }

        var availableIndices = [];
        for (var reqAns in reqAnswers) {
          availableIndices.push(parseInt(reqAns));
        }
        for (var oneInx of allReqQuestIndices) {
          if (availableIndices.indexOf(oneInx) === -1) {
            // console.log("Missing questions 222", availableIndices, oneInx, allReqQuestIndices, allQuestions);

            isAllValid = false;
            break;
          }
        }
      }

      if (!!isAllValid) {
        setCanProceed(true);
        //setStepsCompleted(2);
      } else {
        setCanProceed(false);
        //setStepsCompleted(1);
      }
    }

    if (currentStep === 3 || stepNew === 3) {
      var answerType = getConsentWeight(answers, questions);

      var totalCount = 0;
      for (var oAnsw in answers) {
        if (Array.isArray(answers[oAnsw])) {
          var addUp = 0;
          for (var oAnsw2 of answers[oAnsw]) {
            if (oAnsw2.isChecked) {
              addUp = 1;
            }
          }
          totalCount += addUp;
        } else {
          totalCount++;
        }
      }

      var targetId = -1;
      for (var question of allQuestions.sections[allQuestions.sections.length - 1].questions) {
        if (question.question_type === "dateOfBirth") {
          targetId = question.question_id;
        }
      }

      // var signatureId = -1;
      // for (var questionSig of allQuestions.sections[allQuestions.sections.length - 1].questions) {
      //   if (questionSig.question_type === "digitalSignitaure") {
      //     signatureId = question.question_id;
      //   }
      // }

      var validConsent = totalCount >= (!consentShowOthers ? 8 : 5) && answers[targetId] && answers[24] && answers[25] && answers[32] && answers[47] && answers[77] && answers[78] && answers[81] && answers[82] && answers[83] && answers[78] !== undefined && answers[78].length > 0;
      handleAgeValidation(answers[targetId] ? answers[targetId] : "");

      if (consentShowOthers === true && answers[23] && Object.keys(answers).length > 16) {
        if (answers[23] === "I have consulted with my health care provider who has recommended that I become more physically active." || answers[23] === "I am comfortable with becoming more physically active on my own without consulting my health care provider.") {
          validConsent = true;
        } else {
          validConsent = false;
        }
      } else if (consentShowOthers === false && Object.keys(answers).length > 15) {
        validConsent = true;
      } else {
        validConsent = false;
      }

      if (answers[32] && answers[32] === "I am completing this questionnaire for my child/dependent as parent/guardian") {
        if (answers[72] !== undefined && answers[72].replace(/\s+/g, "").trim().length >= 3 && answers[73] !== undefined) {
          validConsent = true;
        } else {
          validConsent = false;
        }
      }

      if (consentShowOthers === false) {
        delete answers[23];
      }

      if (!!validConsent) {
        setConsentAnswerType(answerType);
        setCanProceed(true);
        //setStepsCompleted(3);
      } else {
        setCanProceed(false);
        //setStepsCompleted(2);
      }
    }
  };

  const [birthDate, setBirthDate] = useState("");
  const [childBirthDate, setChildBirthDate] = useState("");
  const [isAdult, setIsAdult] = useState(true);
  const [adultError, setIsAdultError] = useState("");
  const handleBirthDate = (question, opt, questions, val) => {
    var newOpt = opt;
    if (val === 2) {
      if (/[\/]/.test(newOpt) && testDateValidity(newOpt) !== true) {
        if (/^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{4})*$/.test(newOpt)) {
          // valid date, check for missing zeros
          newOpt = newOpt.split("/");
          if (newOpt[0].length == 1) {
            newOpt[0] = "0" + newOpt[0];
          }
          if (newOpt[1].length == 1) {
            newOpt[1] = "0" + newOpt[1];
          }
          newOpt = newOpt.join("");
        }

        newOpt = newOpt.split("/");
        newOpt = newOpt.join("");
      }
      if (/[\.]/.test(opt) && testDateValidity(newOpt) !== true) {
        newOpt = newOpt.split(".");
        newOpt = newOpt.join("");
      }
      if (!!testDateValidity(newOpt)) {
        handleAgeValidation(testDateValidity(newOpt));
        handleAnswer(question, testDateValidity(newOpt), questions);
        setBirthDate(testDateValidity(opt));
      } else {
        handleAnswer(question, "", questions);
        setIsAdultError("");
        setBirthDate(opt);
      }
    } else {
      if (/[\/]/.test(newOpt) && testDateValidity(newOpt) !== true) {
        if (/^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{4})*$/.test(newOpt)) {
          // valid date, check for missing zeros
          newOpt = newOpt.split("/");
          if (newOpt[0].length == 1) {
            newOpt[0] = "0" + newOpt[0];
          }
          if (newOpt[1].length == 1) {
            newOpt[1] = "0" + newOpt[1];
          }
          newOpt = newOpt.join("");
        }

        newOpt = newOpt.split("/");
        newOpt = newOpt.join("");
      }
      if (/[\.]/.test(opt) && testDateValidity(newOpt) !== true) {
        newOpt = newOpt.split(".");
        newOpt = newOpt.join("");
      }
      if (!!testDateValidity(newOpt)) {
        //handleAgeValidation(testDateValidity(newOpt));
        handleAnswer(question, testDateValidity(newOpt), questions);
        setChildBirthDate(testDateValidity(opt));
      } else {
        handleAnswer(question, "", questions);
        setIsAdultError("");
        setChildBirthDate(opt);
      }
    }
  };

  const testDateValidity = (opt) => {
    let reg = /^(?:(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)[0-9]{2})$/;

    if (reg.test(opt)) {
      var fixedOpt = opt.replace(reg, "$1/$2/$3" + opt[opt.length - 2] + opt[opt.length - 1]);
      return fixedOpt;
    } else {
      return false;
    }
  };

  const handleAgeValidation = (dateOpt) => {
    let currentYear = new Date().getFullYear();
    let dateArr = dateOpt.split("/");
    let yearOfBirth = parseInt(dateArr[2]);
    let checkIsAdult = currentYear - yearOfBirth;
    let adultVar = true;
    let errorMessage = "";
    if (checkIsAdult < 18) {
      adultVar = false;
      errorMessage = "You have to be over 18 to proceed";
    } else {
      adultVar = true;
    }
    setIsAdult(adultVar);
    setIsAdultError(errorMessage);
    return adultVar;
  };

  return (
    <>
      {(currentStep === 4 && consentAnswerType === "No") || hideHeader ? (
        ""
      ) : (
        <>
          <Header inQuestionnaire={true} questionsNum={4} questionsDone={currentStep} />
          {isLoading ? (
            <></>
          ) : (
            <>
              <QuestionareSteps currentStep={currentStep} setCurrentStep={handleStep} stepsCompleted={stepsCompleted} />
            </>
          )}
        </>
      )}
      {isLoading ? (
        <div className="loader_full_container">
          <div className="p_load"></div>
        </div>
      ) : (
        <>
          {currentStep === 1 && <QuestionareForm allQuestions={allQuestions} allAnswers={allAnswers} handleAnswer={handleAnswer} setMainArea={handleMainProblemArea} isInError={errorQuestions} />}
          {currentStep === 2 && <QuestionareSecondStep allQuestions={allQuestions} allAnswers={allAnswers} setAllAnswers={setAllAnswers} handleChecked={handleChecked} handleAnswer={handleAnswer} handleOther={handleOther} isInError={errorQuestions} />}
          {currentStep === 3 && <ConsentForm allQuestions={allQuestions} allAnswers={allAnswers} handleChecked={handleChecked} handleAnswer={handleAnswer} handleAnswerHeight={handleAnswerHeight} handleMultiSelectAnswer={handleMultiSelectAnswer} consentShowOthers={consentShowOthers} handleOther={handleOther} birthDate={birthDate} childBirthDate={childBirthDate} isAdult={isAdult} adultError={adultError} handleBirthDate={handleBirthDate} isInError={errorQuestions} />}
          {currentStep === 4 && (consentAnswerType === "No" && toQuestionaire === false ? <AppointmentBook allAnswers={allAnswers} setHideHeader={setHideHeader} setStepsCompleted={setStepsCompleted} painScale={painScale} questionnaireId={questionnaireToCheck} allQuestions={allQuestions} disableOneToOne={disableOneToOne} /> : toQuestionaire === true && consentAnswerType === "No" ? <LandingPage fromAppointmentBook={false} questionnaireId={questionnaireToCheck} /> : <LandingPage fromQuestionare={true} />)}
          {currentStep >= 4 ? "" : <QuestionareNext currentStep={currentStep} setCurrentStep={handleStep} canProceed={canProceed} setErrorQuestions={setErrorQuestions} isInError={errorQuestions} missingAnsw={missingAnsw} />}
        </>
      )}
    </>
  );
};

export default Questionare;
